import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = { class: "form-group mb-3 d-flex flex-wrap align-items-center gap-2" }
const _hoisted_6 = { class: "small text-muted" }
const _hoisted_7 = { class: "col-12" }
const _hoisted_8 = { class: "form-group mb-3" }
const _hoisted_9 = { class: "text-muted ms-2" }
const _hoisted_10 = { class: "col-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[5] || (_cache[5] = _createElementVNode("label", {
              class: "mb-0 text-nowrap",
              for: "transferDate"
            }, "Jour de virement :", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "transferDate",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.transferDate) = $event)),
              type: "date",
              class: "form-control w-auto",
              onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.getClients && _ctx.getClients(...args)))
            }, null, 544), [
              [_vModelText, _ctx.transferDate]
            ]),
            _createElementVNode("button", {
              type: "button",
              class: _normalizeClass(["btn text-nowrap", _ctx.transferDate ? 'btn-outline-secondary' : 'btn-secondary']),
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.showAllDates && _ctx.showAllDates(...args)))
            }, " Toutes les dates ", 2)
          ]),
          _createElementVNode("p", _hoisted_6, [
            (_ctx.transferDate)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _cache[6] || (_cache[6] = _createTextVNode(" Magasins dont le jour de virement est le ", -1)),
                  _createElementVNode("b", null, _toDisplayString(_ctx.formatDay(_ctx.transferDate)), 1),
                  _createTextVNode(" : " + _toDisplayString(_ctx.dueClients.length) + " sur " + _toDisplayString(_ctx.clientList.length) + ". ", 1)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode("Tous les magasins avec des colis à facturer.")
                ], 64))
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _cache[8] || (_cache[8] = _createElementVNode("label", null, "Magasins :", -1)),
            _createVNode(_component_v_select, {
              class: "custom-select-height",
              modelValue: _ctx.client,
              "onUpdate:modelValue": [
                _cache[3] || (_cache[3] = ($event: any) => ((_ctx.client) = $event)),
                _ctx.handleAgencySelection
              ],
              options: _ctx.dueClients,
              label: "store"
            }, {
              option: _withCtx(({ store, nb_colis, transfer_days_label }) => [
                _createElementVNode("span", null, _toDisplayString(store) + " - " + _toDisplayString(nb_colis) + " Colis", 1),
                _createElementVNode("small", _hoisted_9, "(Virement : " + _toDisplayString(transfer_days_label) + ")", 1)
              ]),
              "no-options": _withCtx(() => _cache[7] || (_cache[7] = [
                _createTextVNode("Aucun magasin à virer ce jour", -1)
              ])),
              _: 1
            }, 8, ["modelValue", "options", "onUpdate:modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          (_ctx.auth.can('ADD_INV'))
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                style: {"float":"right"},
                variant: "btn btn-primary",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.addInvoice && _ctx.addInvoice(...args))),
                class: "btn btn-primary"
              }, " Ajouter "))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}